import { useState, useEffect } from "react";
import "./App.scss";

export default function NotFound() {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const interval = setInterval(() => {
            const newCount = countdown - 1;
            if (newCount < 0) {
                returnHome();
            } else {
                setCountdown(newCount);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [countdown]);

    function returnHome() {
        window.location.href = '/';
    }

    return (
        <div className="page">
            <div className="main">
                <img src="icon.svg" alt="icon" style={{ maxHeight: '20vh' }} />
                <br />
                <br />
                <br />
                <h3>404 - Seite nicht gefunden</h3>
                <p>Es geht zurück in {countdown}.</p>
            </div>
        </div>
    );
}
